import workerCode from 'inline:../workers/storage_worker.js'

// Client for communicating with the storage worker
export class StorageWorkerClient {
  constructor() {
    this.worker = null
    this.messageId = 0
    this.pendingMessages = new Map()
  }

  async init() {
    if (!this.worker) {
      // Create worker from imported text to avoid URL resolution issues
      const blob = new Blob([workerCode], { type: 'application/javascript' })
      this.worker = new Worker(URL.createObjectURL(blob))
      this.worker.onmessage = (e) => {
        const { id, success, result, error } = e.data
        const pendingMessage = this.pendingMessages.get(id)
        
        if (pendingMessage) {
          this.pendingMessages.delete(id)
          if (success) {
            pendingMessage.resolve(result)
          } else {
            pendingMessage.reject(new Error(error))
          }
        }
      }
      
      this.worker.onerror = (error) => {
        console.error('Storage worker error:', error)
      }
    }
  }


  async #sendMessage(method, params) {
    await this.init()
    
    const id = ++this.messageId
    
    return new Promise((resolve, reject) => {
      this.pendingMessages.set(id, { resolve, reject })
      
      this.worker.postMessage({
        id,
        method,
        params
      })
      
      // Timeout after 30 seconds
      setTimeout(() => {
        if (this.pendingMessages.has(id)) {
          this.pendingMessages.delete(id)
          reject(new Error('Storage operation timeout'))
        }
      }, 30000)
    })
  }

  async storeFile(subjectId, fileName, fileData) {
    return this.#sendMessage('storeFile', { subjectId, fileName, fileData })
  }

  async getFile(subjectId, fileName) {
    return this.#sendMessage('getFile', { subjectId, fileName })
  }

  async listFiles(subjectId) {
    return this.#sendMessage('listFiles', { subjectId })
  }

  async deleteSubject(subjectId) {
    return this.#sendMessage('deleteSubject', { subjectId })
  }

  terminate() {
    if (this.worker) {
      this.worker.terminate()
      this.worker = null
    }
  }
}